import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.1_@azure+identity@4.7.0_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.1_eslint@9_lkihim2quytil5hawyhmuxdspa/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}